__turbopack_context__.v({
  "appLayoutContentContainer": "renderEditorial-module-scss-module__hAfXPG__appLayoutContentContainer",
  "buttonContainer": "renderEditorial-module-scss-module__hAfXPG__buttonContainer",
  "buttonLinkContainer": "renderEditorial-module-scss-module__hAfXPG__buttonLinkContainer",
  "descriptionWrapper": "renderEditorial-module-scss-module__hAfXPG__descriptionWrapper",
  "gridContent": "renderEditorial-module-scss-module__hAfXPG__gridContent",
  "header": "renderEditorial-module-scss-module__hAfXPG__header",
  "headerContainer": "renderEditorial-module-scss-module__hAfXPG__headerContainer",
  "imageContainer": "renderEditorial-module-scss-module__hAfXPG__imageContainer",
  "inlineContentContainer": "renderEditorial-module-scss-module__hAfXPG__inlineContentContainer",
  "linkContainer": "renderEditorial-module-scss-module__hAfXPG__linkContainer",
  "pageSectionContainer": "renderEditorial-module-scss-module__hAfXPG__pageSectionContainer",
  "standardContentContainer": "renderEditorial-module-scss-module__hAfXPG__standardContentContainer",
  "textContainer": "renderEditorial-module-scss-module__hAfXPG__textContainer",
  "titleWrapper": "renderEditorial-module-scss-module__hAfXPG__titleWrapper",
  "welcomeContentContainer": "renderEditorial-module-scss-module__hAfXPG__welcomeContentContainer",
  "welcomeHeading": "renderEditorial-module-scss-module__hAfXPG__welcomeHeading",
});
